import { render, staticRenderFns } from "./waybillTrajectory.vue?vue&type=template&id=10890bae&scoped=true&"
import script from "./waybillTrajectory.vue?vue&type=script&lang=js&"
export * from "./waybillTrajectory.vue?vue&type=script&lang=js&"
import style0 from "./waybillTrajectory.vue?vue&type=style&index=0&id=10890bae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10890bae",
  null
  
)

export default component.exports